export const updateMapCenterLatLng = mapCenter => ({
    type: 'SET_MAP_CENTER_REFERENCE',
    payload: mapCenter
})

export const updateMapCenterNull = mapCenter => ({
    type: 'SET_MAP_CENTER_NULL',
})
